import { User } from "../user/user.model";
import { AccountObject, IAccountObjectArgs } from "../account-object/account-object.model";

export interface IMemberUserArgs extends IAccountObjectArgs {
    user: User;
    accessGroups: Array<string>;
    contactTypes: Array<string>;
    lookupTypes: Array<string>;
    jobTypes: Array<string>;
    taskTypes: Array<string>;
    jobStatuses: Array<string>;
    admin: boolean;
}

const defaults = {
    user: undefined,
    accessGroups: [],
    contactTypes: [],
    lookupTypes: [],
    jobTypes: [],
    taskTypes: [],
    jobStatuses: [],
    admin: false
} as IMemberUserArgs;

export class MembershipUser extends AccountObject {
    user: User;
    accessGroups: Array<string> = [];
    contactTypes: Array<string> = [];
    lookupTypes: Array<string> = [];
    jobTypes: Array<string> = [];
    taskTypes: Array<string> = [];
    jobStatuses: Array<string> = [];
    admin: boolean = undefined;

    constructor(data?: IMemberUserArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/membership-user/membership-user.model.ts